export default {
    SDRS: require("./SDRS.png"),

    BioThomas: require("./BioThomas.png"),
    BioMina: require("./BioMina.png"),
    BioAntonio: require("./BioAntonio.png")
} as { [key: string]: any };